import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
// Common data transfers
export var DataTransfers = {
  /**
   * Application specific resource transfer type
   */
  RESOURCES: 'ResourceURLs',

  /**
   * Browser specific transfer type to download
   */
  DOWNLOAD_URL: 'DownloadURL',

  /**
   * Browser specific transfer type for files
   */
  FILES: 'Files',

  /**
   * Typically transfer type for copy/paste transfers.
   */
  TEXT: 'text/plain'
};
export var DragAndDropData = /*#__PURE__*/function () {
  function DragAndDropData(data) {
    _classCallCheck(this, DragAndDropData);

    this.data = data;
  }

  _createClass(DragAndDropData, [{
    key: "update",
    value: function update() {// noop
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.data;
    }
  }]);

  return DragAndDropData;
}();
export var StaticDND = {
  CurrentDragAndDropData: undefined
};